import React, { useState ,useEffect} from 'react';
import { Row, Container, Col, Form, Button, Modal, Spinner } from "react-bootstrap";
import Multiselect from 'multiselect-react-dropdown';
import N from '../lib/Network'
import AC from '../lib/AppConsts'
const RoleConfiguration = ({ showUserPopup, closeModal }) =>{
    const [errors,setErrors] = useState({});
    const [roleName,setRoleName] = useState('');
    const [product,setProduct] = useState('');
    const [activity,setActivity] = useState([]);
    const [productData,setProductData] = useState('');
    const [activityData,setActivityData] = useState('');
    const [status,setStatus] = useState('');
    useEffect(() => {
        fetchProductData();
        fetchActivityData();
      }, [])
      const closePopup = () => {
        closeModal();
        clearState();
    }
    const current = new Date();
    const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
    const fetchProductData = () => {
        N.getApi('getProductList')
          .then(response => {
            setProductData(JSON.parse(response.data.responseJson))
          })
      }
    const onselectProduct = (data) =>{
        setProduct(data);
    } 
    const onRemoveProduct =  (data) => {
        setProduct(data);
    }
    const fetchActivityData = () => {
        N.getApi('getActivityList')
          .then(response => {
            setActivityData(JSON.parse(response.data.responseJson))
          })
      }
    const onselectActivity = (data) =>{
        setActivity(data);
    } 
    const onRemoveActivity =  (data) => {
        setActivity(data);
    }
    const handleChange = (event) => {
        if (event.target.name === 'roleName') {
            errors["roleName"] ="";
            setRoleName( event.target.value );;
            
        }
        if (event.target.name === 'status') {
            if(event.target.value != 0){
                errors["status"] ="";
                setStatus( event.target.value )
            }else{
            errors["status"] ="";
            setStatus();
            }
        }
    }
    const validateForm = () => {
        let formIsValid = true;
        let err = {};
        if(roleName ==="" || roleName.length<=0){
            err["roleName"] = "Role Name cannot be empty";
          formIsValid= false;
        }if(product ==="" || product.length<=0){
            err["product"] = "Select Product Name";
            formIsValid= false;
        }
        if(activity ==="" || activity.length<=0){
            err["activity"] = "Select Activity Name";
            formIsValid= false;
        }
        if(status ==="" || status ===undefined){
            err["status"] = "Select status ";
            formIsValid= false;
        }
        setErrors(err);
        return formIsValid;
    }
    const saveRoleMaster = (event) => {
        event.preventDefault()
        let isThisValidForm = false;
        if(validateForm()){
           isThisValidForm = true;
        }
        if(isThisValidForm){
        var TabObj = {
            activity: activity,
            roleName: roleName,
            roleId: "0",
            action: AC.ACTION_SAVE,
            roleStatus: status,
            roleCreatedDate: date,
            roleCreatedId: localStorage.getItem("userId"),
        
        }
            return N.postApi('createRole',TabObj)
            .then(res => {
                if(res.data.responseStatus === AC.STATUS_SUCCESS){
                    alert("Record Saved Suceesfully");
                    clearState();
                    window.location.reload(true);
                }else{
                    alert("Record Not Saved Suceesfully")
                }
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }
    const clearState = () =>{
        setActivity();
        setRoleName();
        setStatus();        
    }
    return(
    <Modal id="addUser" show={showUserPopup}  animation={true}  size="xl">
    <Modal.Header closeButton onClick={closePopup}>
        <Modal.Title><h5 className="headerTitle">Create Role</h5></Modal.Title>
    </Modal.Header>
    <Modal.Body>
    <Container fluid>
        <Row>
            <Col xs={3} md={3} lg={3}>
                <Form.Group className="mb-3">
                    <Form.Label>Role Name</Form.Label>
                    <Form.Control  name="roleName" type="text" className="form-control" onChange={handleChange} placeholder="Enter Role Name" />
                    <div className="invalid-feedback">{errors["roleName"]}</div>
                </Form.Group>
            </Col>
            <Col xs={3} md={3} lg={3}>
                <Form.Group className="mb-3">
                <Form.Label>Product Name</Form.Label>  
                <Multiselect
                    name='product'
                    options={productData?.Payload?.productList}
                    displayValue="productName"
                    closeOnSelect={true}
                    onSelect={onselectProduct}
                    onRemove={onRemoveProduct}
                />
                        <div className="invalid-feedback">{errors["product"]}</div>
                </Form.Group>
            </Col>
            <Col xs={3} md={3} lg={3}>
                <Form.Group className="mb-3">
                <Form.Label>Activity Name</Form.Label>  
                    <Multiselect
                        name='activity'
                        options={activityData?.Payload?.ActivityList}
                        displayValue="activityName"
                        closeOnSelect={true}
                        onSelect={onselectActivity}
                        onRemove={onRemoveActivity}
                        />
                        <div className="invalid-feedback">{errors["activity"]}</div>
                </Form.Group> 
            </Col>
            <Col xs={3} md={3} lg={3}>
                <Form.Group className="mb-3">
                    <Form.Label>Status</Form.Label>
                    <Form.Select name="status" className="form-control"  onChange={handleChange}>
                        <option value="0" >- Select Role Status -</option>
                        <option value="Y">Active</option>
                        <option value="N">Inactive</option>
                    </Form.Select>
                    <div className="invalid-feedback">{errors["status"]}</div>
                </Form.Group>
            </Col>
            
        </Row>
        </Container>
            </Modal.Body>
            <Modal.Footer className='text-center'>
                <Button type="button" className="btn btn-sm btn-danger shadow-sm" onClick={closePopup} > Cancel </Button>
                <Button type="button" className="btn btn-sm btn-primary shadow-sm" onClick={saveRoleMaster}> Save </Button>
             </Modal.Footer>
        </Modal>
                
    )
}
export default RoleConfiguration;